export default "__VITE_ASSET__047dd789__"